import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, imgUrl, formatErr } from "@/lib/api";

const EMPTY = { name: "", short_description: "", description: "", price: "", category: "Manutenzione", image_url: "", active: true };

export default function ProductForm({ product, onClose, onSaved }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (product) setF({ ...EMPTY, ...product }); }, [product]);

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const uploadImg = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/admin/upload-image", fd);
      setF((x) => ({ ...x, image_url: data.url }));
    } catch (er) {
      toast.error(formatErr(er));
    }
  };

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = { name: f.name, short_description: f.short_description, description: f.description, price: parseFloat(f.price), category: f.category, image_url: f.image_url, active: f.active };
    try {
      if (product?.id) await api.put(`/admin/products/${product.id}`, body);
      else await api.post("/admin/products", body);
      toast.success("Salvato");
      onSaved();
    } catch (er) {
      toast.error(formatErr(er));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0F0F12] border border-red-900/40 text-white max-w-lg max-h-[90vh] overflow-y-auto" data-testid="admin-product-dialog">
        <DialogHeader><DialogTitle className="tms-title text-3xl">{product?.id ? "Modifica" : "Nuovo"} articolo</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <input className="tms-input" placeholder="Nome" required value={f.name} onChange={set("name")} data-testid="product-form-name" />
          <div className="grid grid-cols-2 gap-3">
            <input className="tms-input" type="number" step="0.01" min="0.5" placeholder="Prezzo €" required value={f.price} onChange={set("price")} data-testid="product-form-price" />
            <input className="tms-input" placeholder="Categoria" value={f.category} onChange={set("category")} data-testid="product-form-category" />
          </div>
          <input className="tms-input" placeholder="Descrizione breve" value={f.short_description} onChange={set("short_description")} data-testid="product-form-short" />
          <textarea className="tms-input min-h-[120px]" placeholder="Descrizione completa" value={f.description} onChange={set("description")} data-testid="product-form-description" />
          <div className="flex items-center gap-4">
            {f.image_url && <img src={imgUrl(f.image_url)} alt="" className="w-24 h-18 object-cover" />}
            <label className="btn-ghost text-xs cursor-pointer" data-testid="product-form-image-label">
              <Upload size={14} /> Foto
              <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={uploadImg} data-testid="product-form-image-input" />
            </label>
          </div>
          <button className="btn-red w-full" disabled={busy} data-testid="product-form-save">{busy ? "Salvataggio…" : "Salva"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
